import { Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { BodyM, HeaderS } from "ui/Typography/Typography";

export function NoBatteryCountScheduled() {
  return (
    <Flex
      h="full"
      w="full"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      gap="s200"
      bgColor="white"
    >
      <HeaderS>
        <FormattedMessage id="pages.inventory.battery-management-page.placeholders.no-battery-count-scheduled.title" />
      </HeaderS>
      <BodyM color="grey.800" maxW="293px">
        <FormattedMessage id="pages.inventory.battery-management-page.placeholders.no-battery-count-scheduled.body" />
      </BodyM>
    </Flex>
  );
}
